import { IDailyDeal, IDailyDealsResponse } from 'models/daily-deals/i-daily-deals';

/**
 * Transform API data to component format
 * Converts from IDailyDealsResponse (API format) to IDailyDeal[] (component format)
 */
export const transformDealsData = (dealsData: IDailyDealsResponse): IDailyDeal[] => {
  return dealsData.map(({ asset, items, package_type }) => ({
    asset,
    items: items.map(({ currency, all_sales, amount, price }) => ({
      currency,
      allSales: all_sales,
      meta: { amount, price },
    })),
    type: package_type,
  }));
};

/**
 * Extract asset IDs from deals array
 */
export const getAssetIdsFromDeals = (deals: IDailyDeal[]): number[] => {
  return deals.map((deal) => deal.asset.id);
};
